import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import SeniorCitizenContainer from './senior-citizen/container/SeniorCitizenContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';

// temporary template for presentation only
const ComingSoonTemplateContainer = () => (
  <div className="container">
    <div className="row">
      <div className="col-12 d-flex justify-content-center align-items-center">
        <p className="p-4 m-4 h1 text-muted">
          <strong>COMING SOON...</strong>
        </p>
      </div>
    </div>
  </div>
);

const SocialAmeliorationContainer = ({ match }) => {
  return (
    <div className="module-inner">
      <div className="module-inner-title">Social Amelioration</div>
      <div className="generic-module-nav mb-3">
        <NavLink
          exact
          className="nav-link"
          activeClassName="active"
          to="/social-ameliorations"
        >
          Dashboard
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/social-ameliorations/seniors"
        >
          SENIOR CITIZEN
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/social-ameliorations/pwd"
        >
          PWD
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/social-ameliorations/students"
        >
          STUDENTS
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/social-ameliorations/single-parent"
        >
          SINGLE PARENTS
        </NavLink>
      </div>
      <Switch>
        {/* TransactionContainer === Dashboard */}
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        {/* NOTE: rename `SeniorCitizenContainer` with proper name based on content later */}
        <Route
          path={`${match.path}/seniors`}
          component={SeniorCitizenContainer}
        />
        <Route
          path={`${match.path}/pwd`}
          component={ComingSoonTemplateContainer}
        />
        <Route
          path={`${match.path}/students`}
          component={ComingSoonTemplateContainer}
        />
        <Route
          path={`${match.path}/single-parent`}
          component={ComingSoonTemplateContainer}
        />
      </Switch>
    </div>
  );
};

SocialAmeliorationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(SocialAmeliorationContainer);
